import { IColumn } from "@fluentui/react";

const HEADER_BAR_HEIGHT = 20;
const BODY_BAR_HEIGHT = 12;
const CHECKBOX_COLUMN_WIDTH = 36;
const COLUMN_GAP = 42;

// Column widths for the 6 data columns. Both header and body shimmer rows use
// these same widths so columns align vertically.
const DATA_COLUMN_WIDTHS = [156, 64, 198, 244, 144, 196];

// Bar widths inside each header column.
const HEADER_BAR_WIDTHS = [110, 36, 150, 196, 110, 144];

// Jitter is a small variation added to each body cell's bar width so that the rows don't all look identical.
const JITTER_RANGE = 50;
const JITTER_ROW_STEP = 17;
const JITTER_COL_STEP = 23;
const MIN_BODY_BAR_WIDTH = 40;

// 4 CommandBar button placeholders.
const COMMAND_BAR_BUTTON_WIDTHS = [86, 110, 124, 96];

// 5 button placeholders for search box, search button, add filter etc.
// Rendered as separate <Shimmer>s so the gray strip shows through between
// items — ShimmerElementsGroup gap elements paint the wrapper background
// (white by default), which would create white slashes across the gray strip.
const FILTER_BAR_ITEM_WIDTHS = [220, 72, 120, 124, 110];

// Checkbox column is passed as a regular column (instead of using
// selectionMode=multiple) so we have full control over the checkbox shimmer shape.
const GRID_COLUMNS: IColumn[] = [
  {
    key: "checkbox",
    name: "",
    fieldName: "checkbox",
    minWidth: CHECKBOX_COLUMN_WIDTH,
    maxWidth: CHECKBOX_COLUMN_WIDTH,
    isResizable: false,
  },
  ...DATA_COLUMN_WIDTHS.map<IColumn>((w, i) => ({
    key: `c${i + 1}`,
    name: "",
    fieldName: `c${i + 1}`,
    minWidth: w,
    maxWidth: w,
    isResizable: false,
  })),
];

export const schemeSkeletonConstants = {
  HEADER_BAR_HEIGHT,
  BODY_BAR_HEIGHT,
  CHECKBOX_COLUMN_WIDTH,
  COLUMN_GAP,
  DATA_COLUMN_WIDTHS,
  HEADER_BAR_WIDTHS,
  JITTER_RANGE,
  JITTER_ROW_STEP,
  JITTER_COL_STEP,
  MIN_BODY_BAR_WIDTH,
  COMMAND_BAR_BUTTON_WIDTHS,
  FILTER_BAR_ITEM_WIDTHS,
  GRID_COLUMNS,
};
